/**
 * @flow
 * @relayHash 1276abd2e02819c4dc17e3514e5da1b7
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Routes_user$ref = any;
export type QueryComponentQueryVariables = {|
  countPending: number,
  afterPending?: ?string,
  countAccepted: number,
  afterAccepted?: ?string,
  countRejected: number,
  afterRejected?: ?string,
  countCancelled: number,
  afterCancelled?: ?string,
|};
export type QueryComponentQueryResponse = {|
  +user: ?{|
    +$fragmentRefs: Routes_user$ref
  |}
|};
export type QueryComponentQuery = {|
  variables: QueryComponentQueryVariables,
  response: QueryComponentQueryResponse,
|};
*/

/*
query QueryComponentQuery(
  $countPending: Int!
  $afterPending: String
  $countAccepted: Int!
  $afterAccepted: String
  $countRejected: Int!
  $afterRejected: String
  $countCancelled: Int!
  $afterCancelled: String
) {
  user {
    ...Routes_user_3WGgZc
    id
  }
}

fragment Routes_user_3WGgZc on UserType {
  ...BaseHorizontal_user
  ...Dashboard_user_3WGgZc
  ...Account_user
  ...Absences_user_3WGgZc
  displayName
  isStaff
}

fragment BaseHorizontal_user on UserType {
  ...HeaderHorizontal_user
}

fragment Dashboard_user_3WGgZc on UserType {
  id
  email
  ...News_user
  ...Tasks_user_3WGgZc
  ...Schedule_user
}

fragment Account_user on UserType {
  pk
  firstName
  lastName
  email
  phoneNumber
  bankAccount
}

fragment Absences_user_3WGgZc on UserType {
  ...AbsencesCalendar_user
  ...AbsencesTabs_user_3WGgZc
  ...AbsencesAndVacationsModal_user
  unusedAbsenceDays
}

fragment AbsencesCalendar_user on UserType {
  monthAbsences: absences(last: 512) {
    edges {
      node {
        dateFrom
        dateTo
        note
        absenceTypeDisplay
        absenceType
        absenceLength
        status
        statusDisplay
        id
        pk
        statusComment
        file
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
  bankHolidays(first: 10) {
    edges {
      node {
        dateFrom
        dateTo
        description
        id
      }
    }
  }
  remoteDays(first: 30) {
    edges {
      node {
        id
        pk
        date
      }
    }
  }
  calendarMeetings: meetings(priority: true) {
    edges {
      node {
        createdAt
        updatedAt
        body
        name
        receivers {
          edges {
            node {
              lastName
              firstName
              pk
              id
            }
          }
        }
        createdBy {
          lastName
          firstName
          id
        }
        meetingDate
        pk
        id
        deleted
        public
        priority
      }
    }
  }
}

fragment AbsencesTabs_user_3WGgZc on UserType {
  notifications(management: false, absenceStatus: ["r", "c", "a"], absenceType: ["v", "d", "o"], first: 16, hidden: false) {
    edges {
      cursor
      node {
        pk
        id
        seen
        hidden
        absenceStatus
        absence {
          status
          absenceType
          id
        }
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...AcceptedAbsencesTab_user_3QllOe
  ...PendingAbsencesTab_user_1Uuf9N
  ...RejectedAbsencesTab_user_1E8eg8
  ...CancelledAbsencesTab_user_4ywQFZ
}

fragment AbsencesAndVacationsModal_user on UserType {
  allAbsences: absences(last: 512) {
    edges {
      node {
        dateFrom
        absenceLength
        dateTo
        status
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment AcceptedAbsencesTab_user_3QllOe on UserType {
  acceptedAbsences: absences(types: ["v", "d", "o"], statuses: ["a"], future: true, first: $countAccepted, after: $afterAccepted) {
    edges {
      node {
        dateFrom
        dateTo
        note
        statusComment
        absenceTypeDisplay
        status
        createdAt
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment PendingAbsencesTab_user_1Uuf9N on UserType {
  pendingAbsences: absences(types: ["v", "d", "o"], statuses: ["p"], future: true, first: $countPending, after: $afterPending) {
    edges {
      node {
        id
        pk
        dateFrom
        dateTo
        note
        statusComment
        absenceTypeDisplay
        absenceLength
        absenceType
        status
        createdAt
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment RejectedAbsencesTab_user_1E8eg8 on UserType {
  rejectedAbsences: absences(types: ["v", "d", "o"], statuses: ["r"], future: true, first: $countRejected, after: $afterRejected) {
    edges {
      node {
        dateFrom
        dateTo
        note
        statusComment
        absenceTypeDisplay
        status
        createdAt
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment CancelledAbsencesTab_user_4ywQFZ on UserType {
  cancelledAbsences: absences(types: ["v", "d", "o"], statuses: ["c"], future: true, first: $countCancelled, after: $afterCancelled) {
    edges {
      node {
        dateFrom
        dateTo
        note
        statusComment
        absenceTypeDisplay
        status
        createdAt
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment News_user on UserType {
  ...Clock_user
  ...UsersTable_user
}

fragment Tasks_user_3WGgZc on UserType {
  ...TaskTimer_user
  ...CompletedTasks_user
  ...ToDo_user
  ...Events_user
  ...ReportsGraph_user
  ...VacationsBar_user_3WGgZc
}

fragment Schedule_user on UserType {
  ...WeekSchedule_user
  ...ModalWeek_user
  firstTimetable
  secondTimetable
  timetables(last: 10, orderByWeek: true) {
    edges {
      node {
        year
        weekOfYear
        dayPresences
        dayPresencesIncidental
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
  timetableTemplate {
    edges {
      node {
        id
        active
        dayPresences
      }
    }
  }
}

fragment WeekSchedule_user on UserType {
  ...ModalWeek_user
  firstTimetable
  secondTimetable
  timetables(last: 10, orderByWeek: true) {
    edges {
      node {
        year
        weekOfYear
        dayPresences
        dayPresencesIncidental
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment ModalWeek_user on UserType {
  currentWeekTimetable {
    dayPresences
    year
    weekOfYear
    id
  }
  id
  pk
  firstTimetable
  secondTimetable
  timetables(last: 10, orderByWeek: true) {
    edges {
      node {
        weekOfYear
        dayPresences
        dayPresencesIncidental
        year
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment TaskTimer_user on UserType {
  ...ModalAddTask_user
}

fragment CompletedTasks_user on UserType {
  ...ModalAddTaskButton_user
  reports(period: 0, last: 100) {
    edges {
      node {
        id
        pk
        afterWork
        project {
          pk
          name
          color
          id
        }
        milestone {
          pk
          id
        }
        reportType {
          pk
          labelDisplay
          color
          id
        }
        numberOfMinutes
        note
        taskId
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
  ...ModalTasksButton_user
}

fragment ToDo_user on UserType {
  ...ModalMore_user
  todos(first: 10) {
    edges {
      node {
        id
        pk
        body
        reminder
        isDone
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment Events_user on UserType {
  ...EventsList_user
  ...MeetingsList_user
  ...DashboardMeetingModal_user
  eventsNotifications: notifications(management: false, meeting: true, first: 16, hidden: false) {
    edges {
      cursor
      node {
        pk
        id
        seen
        hidden
        absenceStatus
        absence {
          status
          absenceType
          id
        }
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReportsGraph_user on UserType {
  projectEmployeesTimeSpent(last: 100) {
    edges {
      node {
        id
        pk
        project {
          name
          id
          pk
          color
        }
        monthlyTimeSpent
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment VacationsBar_user_3WGgZc on UserType {
  ...AbsencesAndVacationsModal_user
  ...AbsencesTabs_user_3WGgZc
}

fragment EventsList_user on UserType {
  lastMessages: receivedMessages(first: 6) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    edges {
      node {
        sender {
          displayName
          id
        }
        body
        createdAt
        sentToAll
        receivers {
          edges {
            node {
              firstName
              lastName
              id
            }
          }
        }
        id
        __typename
      }
      cursor
    }
  }
}

fragment MeetingsList_user on UserType {
  meetings(first: 6) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    edges {
      node {
        createdAt
        updatedAt
        body
        name
        receivers {
          edges {
            node {
              lastName
              firstName
              id
            }
          }
        }
        createdBy {
          lastName
          firstName
          id
        }
        meetingDate
        pk
        id
        deleted
        public
        __typename
      }
      cursor
    }
  }
}

fragment DashboardMeetingModal_user on UserType {
  pk
  id
  users(last: 512) {
    edges {
      node {
        pk
        id
        displayName
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment ModalMore_user on UserType {
  displayName
}

fragment ModalAddTaskButton_user on UserType {
  defaultRole {
    pk
    labelDisplay
    id
  }
  allRoles {
    edges {
      node {
        pk
        labelDisplay
        id
      }
    }
  }
  projectEmployees(first: 100) {
    edges {
      node {
        pk
        active
        project {
          pk
          name
          milestones(active: true) {
            edges {
              node {
                pk
                name
                endDate
                id
              }
            }
          }
          id
        }
        role {
          label
          labelDisplay
          pk
          id
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ModalTasksButton_user on UserType {
  ...CompletedTasksModal_user
  reportsOld: reports(period: 14, last: 70, periodTo: 1) {
    edges {
      node {
        id
        pk
        createdAt
        project {
          pk
          name
          color
          id
        }
        milestone {
          pk
          id
        }
        reportType {
          pk
          labelDisplay
          color
          id
        }
        numberOfMinutes
        note
        taskId
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
  id
}

fragment CompletedTasksModal_user on UserType {
  ...ModalAddTaskButton_user
  reports(period: 0, last: 100) {
    edges {
      node {
        id
        pk
        afterWork
        project {
          pk
          name
          color
          id
        }
        milestone {
          pk
          id
        }
        reportType {
          pk
          labelDisplay
          color
          id
        }
        numberOfMinutes
        note
        taskId
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment ModalAddTask_user on UserType {
  defaultRole {
    pk
    labelDisplay
    id
  }
  allRoles {
    edges {
      node {
        pk
        labelDisplay
        id
      }
    }
  }
  projectEmployees(first: 100) {
    edges {
      node {
        pk
        active
        project {
          pk
          name
          milestones(active: true) {
            edges {
              node {
                pk
                name
                endDate
                id
              }
            }
          }
          id
        }
        role {
          label
          labelDisplay
          pk
          id
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment Clock_user on UserType {
  ...ClockButtons_user
  todayRealWorktime
  todayDeclaredWorktime
  lastActivity {
    activity
    createdAt
    stopBreakTime
    time
    id
  }
  lastActivityToday {
    activity
    createdAt
    stopBreakTime
    time
    id
  }
  absences(today: true) {
    edges {
      node {
        pk
        id
        absenceLength
        status
      }
    }
  }
  todayActivities(first: 20) {
    edges {
      node {
        time
        createdAt
        activity
        activityDisplay
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  reports(period: 0, last: 100) {
    edges {
      node {
        numberOfMinutes
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
  todayAbsences: absences(today: true, last: 1) {
    edges {
      node {
        id
        absenceLength
      }
    }
  }
  latenesses(today: true, first: 1) {
    edges {
      node {
        id
        pk
        declaredTime
        note
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment UsersTable_user on UserType {
  users(last: 512) {
    edges {
      node {
        pk
        displayName
        isRemote
        lastActivityToday {
          activity
          activityDisplay
          time
          stopBreakTime
          id
        }
        todayDeclaredWorktime
        expectedEndWorkTime
        latenesses(today: true) {
          edges {
            node {
              declaredTime
              id
            }
          }
        }
        absences(today: true, statuses: ["a"]) {
          edges {
            node {
              dateFrom
              dateTo
              absenceLength
              absenceTypeDisplay
              absenceType
              id
            }
          }
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment ClockButtons_user on UserType {
  ...EndWorkModal_user
  ...ExtraWorkModal_user
  ...FinishWorkModal_user
  lastActivity {
    activity
    createdAt
    id
  }
}

fragment EndWorkModal_user on UserType {
  ...SmallTaskForm_user
  todayDeclaredWorktime
  todayActivities(first: 20) {
    edges {
      node {
        time
        activity
        activityDisplay
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  defaultRole {
    pk
    labelDisplay
    id
  }
  dailyReport {
    comment
    id
    extraTimeFrom
    extraTimeTo
    pk
  }
  allRoles {
    edges {
      node {
        pk
        labelDisplay
        id
      }
    }
  }
  projectEmployees(first: 100) {
    edges {
      node {
        pk
        project {
          pk
          name
          id
        }
        role {
          label
          labelDisplay
          pk
          id
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  reports(period: 0, last: 100) {
    edges {
      node {
        id
        pk
        afterWork
        project {
          pk
          name
          color
          id
        }
        milestone {
          pk
          id
        }
        reportType {
          pk
          labelDisplay
          color
          id
        }
        numberOfMinutes
        note
        taskId
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment ExtraWorkModal_user on UserType {
  ...SmallTaskForm_user
  todayDeclaredWorktime
  todayActivities(first: 20) {
    edges {
      node {
        time
        activity
        activityDisplay
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  defaultRole {
    pk
    labelDisplay
    id
  }
  dailyReport {
    comment
    id
    extraTimeFrom
    extraTimeTo
    pk
  }
  allRoles {
    edges {
      node {
        pk
        labelDisplay
        id
      }
    }
  }
  projectEmployees(first: 100) {
    edges {
      node {
        pk
        project {
          pk
          name
          id
        }
        role {
          label
          labelDisplay
          pk
          id
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  reports(period: 0, last: 100) {
    edges {
      node {
        id
        pk
        afterWork
        project {
          pk
          name
          color
          id
        }
        reportType {
          pk
          labelDisplay
          color
          id
        }
        numberOfMinutes
        note
        taskId
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment FinishWorkModal_user on UserType {
  ...SmallTaskForm_user
  declaredWorktime(offset: 0)
  dayActivities(offset: 0) {
    edges {
      node {
        time
        activity
        activityDisplay
        id
      }
    }
  }
  lastActivity {
    activity
    createdAt
    stopBreakTime
    time
    id
  }
  lastStartWork {
    time
    id
  }
  defaultRole {
    pk
    labelDisplay
    id
  }
  dailyReportOffset: dailyReport(offset: 0) {
    comment
    id
    extraTimeFrom
    extraTimeTo
    pk
  }
  allRoles {
    edges {
      node {
        pk
        labelDisplay
        id
      }
    }
  }
  projectEmployees(first: 100) {
    edges {
      node {
        pk
        project {
          pk
          name
          id
        }
        role {
          label
          labelDisplay
          pk
          id
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  reportsOffset: reports(period: 0, periodTo: 0, last: 100) {
    edges {
      node {
        id
        pk
        afterWork
        project {
          pk
          name
          color
          id
        }
        reportType {
          pk
          labelDisplay
          color
          id
        }
        numberOfMinutes
        note
        taskId
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment SmallTaskForm_user on UserType {
  defaultRole {
    pk
    labelDisplay
    id
  }
  allRoles {
    edges {
      node {
        pk
        labelDisplay
        id
      }
    }
  }
  projectEmployees(first: 100) {
    edges {
      node {
        pk
        active
        project {
          pk
          name
          milestones(active: true) {
            edges {
              node {
                pk
                name
                endDate
                id
              }
            }
          }
          id
        }
        role {
          label
          labelDisplay
          pk
          id
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment HeaderHorizontal_user on UserType {
  displayName
  isStaff
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: "LocalArgument",
        name: "countPending",
        type: "Int!",
        defaultValue: null,
      },
      {
        kind: "LocalArgument",
        name: "afterPending",
        type: "String",
        defaultValue: null,
      },
      {
        kind: "LocalArgument",
        name: "countAccepted",
        type: "Int!",
        defaultValue: null,
      },
      {
        kind: "LocalArgument",
        name: "afterAccepted",
        type: "String",
        defaultValue: null,
      },
      {
        kind: "LocalArgument",
        name: "countRejected",
        type: "Int!",
        defaultValue: null,
      },
      {
        kind: "LocalArgument",
        name: "afterRejected",
        type: "String",
        defaultValue: null,
      },
      {
        kind: "LocalArgument",
        name: "countCancelled",
        type: "Int!",
        defaultValue: null,
      },
      {
        kind: "LocalArgument",
        name: "afterCancelled",
        type: "String",
        defaultValue: null,
      },
    ],
    v1 = [
      {
        kind: "Literal",
        name: "first",
        value: 6,
        type: "Int",
      },
    ],
    v2 = {
      kind: "ScalarField",
      alias: null,
      name: "startCursor",
      args: null,
      storageKey: null,
    },
    v3 = {
      kind: "ScalarField",
      alias: null,
      name: "endCursor",
      args: null,
      storageKey: null,
    },
    v4 = {
      kind: "ScalarField",
      alias: null,
      name: "hasNextPage",
      args: null,
      storageKey: null,
    },
    v5 = {
      kind: "LinkedField",
      alias: null,
      name: "pageInfo",
      storageKey: null,
      args: null,
      concreteType: "PageInfo",
      plural: false,
      selections: [v2, v3, v4],
    },
    v6 = {
      kind: "ScalarField",
      alias: null,
      name: "displayName",
      args: null,
      storageKey: null,
    },
    v7 = {
      kind: "ScalarField",
      alias: null,
      name: "id",
      args: null,
      storageKey: null,
    },
    v8 = {
      kind: "ScalarField",
      alias: null,
      name: "body",
      args: null,
      storageKey: null,
    },
    v9 = {
      kind: "ScalarField",
      alias: null,
      name: "createdAt",
      args: null,
      storageKey: null,
    },
    v10 = {
      kind: "ScalarField",
      alias: null,
      name: "firstName",
      args: null,
      storageKey: null,
    },
    v11 = {
      kind: "ScalarField",
      alias: null,
      name: "lastName",
      args: null,
      storageKey: null,
    },
    v12 = {
      kind: "ScalarField",
      alias: null,
      name: "__typename",
      args: null,
      storageKey: null,
    },
    v13 = {
      kind: "ScalarField",
      alias: null,
      name: "cursor",
      args: null,
      storageKey: null,
    },
    v14 = {
      kind: "ScalarField",
      alias: null,
      name: "pk",
      args: null,
      storageKey: null,
    },
    v15 = {
      kind: "ScalarField",
      alias: null,
      name: "labelDisplay",
      args: null,
      storageKey: null,
    },
    v16 = [v14, v15, v7],
    v17 = [
      {
        kind: "Literal",
        name: "first",
        value: 100,
        type: "Int",
      },
    ],
    v18 = {
      kind: "ScalarField",
      alias: null,
      name: "active",
      args: null,
      storageKey: null,
    },
    v19 = {
      kind: "ScalarField",
      alias: null,
      name: "name",
      args: null,
      storageKey: null,
    },
    v20 = {
      kind: "LinkedField",
      alias: null,
      name: "pageInfo",
      storageKey: null,
      args: null,
      concreteType: "PageInfo",
      plural: false,
      selections: [v3, v4],
    },
    v21 = {
      kind: "ScalarField",
      alias: null,
      name: "todayDeclaredWorktime",
      args: null,
      storageKey: null,
    },
    v22 = [
      {
        kind: "Literal",
        name: "first",
        value: 20,
        type: "Int",
      },
    ],
    v23 = {
      kind: "ScalarField",
      alias: null,
      name: "time",
      args: null,
      storageKey: null,
    },
    v24 = {
      kind: "ScalarField",
      alias: null,
      name: "activity",
      args: null,
      storageKey: null,
    },
    v25 = {
      kind: "ScalarField",
      alias: null,
      name: "activityDisplay",
      args: null,
      storageKey: null,
    },
    v26 = [
      {
        kind: "ScalarField",
        alias: null,
        name: "comment",
        args: null,
        storageKey: null,
      },
      v7,
      {
        kind: "ScalarField",
        alias: null,
        name: "extraTimeFrom",
        args: null,
        storageKey: null,
      },
      {
        kind: "ScalarField",
        alias: null,
        name: "extraTimeTo",
        args: null,
        storageKey: null,
      },
      v14,
    ],
    v27 = {
      kind: "Literal",
      name: "last",
      value: 100,
      type: "Int",
    },
    v28 = {
      kind: "Literal",
      name: "period",
      value: 0,
      type: "Int",
    },
    v29 = [v27, v28],
    v30 = {
      kind: "ScalarField",
      alias: null,
      name: "afterWork",
      args: null,
      storageKey: null,
    },
    v31 = {
      kind: "ScalarField",
      alias: null,
      name: "color",
      args: null,
      storageKey: null,
    },
    v32 = {
      kind: "LinkedField",
      alias: null,
      name: "project",
      storageKey: null,
      args: null,
      concreteType: "ProjectType",
      plural: false,
      selections: [v14, v19, v31, v7],
    },
    v33 = {
      kind: "LinkedField",
      alias: null,
      name: "milestone",
      storageKey: null,
      args: null,
      concreteType: "MilestoneType",
      plural: false,
      selections: [v14, v7],
    },
    v34 = {
      kind: "LinkedField",
      alias: null,
      name: "reportType",
      storageKey: null,
      args: null,
      concreteType: "RoleType",
      plural: false,
      selections: [v14, v15, v31, v7],
    },
    v35 = {
      kind: "ScalarField",
      alias: null,
      name: "numberOfMinutes",
      args: null,
      storageKey: null,
    },
    v36 = {
      kind: "ScalarField",
      alias: null,
      name: "note",
      args: null,
      storageKey: null,
    },
    v37 = {
      kind: "ScalarField",
      alias: null,
      name: "taskId",
      args: null,
      storageKey: null,
    },
    v38 = {
      kind: "LinkedField",
      alias: null,
      name: "pageInfo",
      storageKey: null,
      args: null,
      concreteType: "PageInfo",
      plural: false,
      selections: [
        {
          kind: "ScalarField",
          alias: null,
          name: "hasPreviousPage",
          args: null,
          storageKey: null,
        },
        v2,
      ],
    },
    v39 = [
      {
        kind: "Literal",
        name: "offset",
        value: 0,
        type: "Int",
      },
    ],
    v40 = {
      kind: "ScalarField",
      alias: null,
      name: "stopBreakTime",
      args: null,
      storageKey: null,
    },
    v41 = [v24, v9, v40, v23, v7],
    v42 = [
      v27,
      v28,
      {
        kind: "Literal",
        name: "periodTo",
        value: 0,
        type: "Int",
      },
    ],
    v43 = {
      kind: "Literal",
      name: "today",
      value: true,
      type: "Boolean",
    },
    v44 = [v43],
    v45 = {
      kind: "ScalarField",
      alias: null,
      name: "absenceLength",
      args: null,
      storageKey: null,
    },
    v46 = {
      kind: "ScalarField",
      alias: null,
      name: "status",
      args: null,
      storageKey: null,
    },
    v47 = [
      {
        kind: "Literal",
        name: "first",
        value: 1,
        type: "Int",
      },
      v43,
    ],
    v48 = {
      kind: "ScalarField",
      alias: null,
      name: "declaredTime",
      args: null,
      storageKey: null,
    },
    v49 = [
      {
        kind: "Literal",
        name: "last",
        value: 512,
        type: "Int",
      },
    ],
    v50 = {
      kind: "Literal",
      name: "statuses",
      value: ["a"],
      type: "[String]",
    },
    v51 = {
      kind: "ScalarField",
      alias: null,
      name: "dateFrom",
      args: null,
      storageKey: null,
    },
    v52 = {
      kind: "ScalarField",
      alias: null,
      name: "dateTo",
      args: null,
      storageKey: null,
    },
    v53 = {
      kind: "ScalarField",
      alias: null,
      name: "absenceTypeDisplay",
      args: null,
      storageKey: null,
    },
    v54 = {
      kind: "ScalarField",
      alias: null,
      name: "absenceType",
      args: null,
      storageKey: null,
    },
    v55 = [
      {
        kind: "Literal",
        name: "last",
        value: 70,
        type: "Int",
      },
      {
        kind: "Literal",
        name: "period",
        value: 14,
        type: "Int",
      },
      {
        kind: "Literal",
        name: "periodTo",
        value: 1,
        type: "Int",
      },
    ],
    v56 = [
      {
        kind: "Literal",
        name: "first",
        value: 10,
        type: "Int",
      },
    ],
    v57 = {
      kind: "ScalarField",
      alias: null,
      name: "meetingDate",
      args: null,
      storageKey: null,
    },
    v58 = [v11, v10, v7],
    v59 = {
      kind: "LinkedField",
      alias: null,
      name: "createdBy",
      storageKey: null,
      args: null,
      concreteType: "UserType",
      plural: false,
      selections: v58,
    },
    v60 = {
      kind: "ScalarField",
      alias: null,
      name: "updatedAt",
      args: null,
      storageKey: null,
    },
    v61 = {
      kind: "ScalarField",
      alias: null,
      name: "deleted",
      args: null,
      storageKey: null,
    },
    v62 = {
      kind: "ScalarField",
      alias: null,
      name: "public",
      args: null,
      storageKey: null,
    },
    v63 = {
      kind: "Literal",
      name: "first",
      value: 16,
      type: "Int",
    },
    v64 = {
      kind: "Literal",
      name: "hidden",
      value: false,
      type: "Boolean",
    },
    v65 = {
      kind: "Literal",
      name: "management",
      value: false,
      type: "Boolean",
    },
    v66 = [
      v63,
      v64,
      v65,
      {
        kind: "Literal",
        name: "meeting",
        value: true,
        type: "Boolean",
      },
    ],
    v67 = [
      {
        kind: "LinkedField",
        alias: null,
        name: "edges",
        storageKey: null,
        args: null,
        concreteType: "NotificationEdge",
        plural: true,
        selections: [
          v13,
          {
            kind: "LinkedField",
            alias: null,
            name: "node",
            storageKey: null,
            args: null,
            concreteType: "NotificationType",
            plural: false,
            selections: [
              v14,
              v7,
              {
                kind: "ScalarField",
                alias: null,
                name: "seen",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "hidden",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "absenceStatus",
                args: null,
                storageKey: null,
              },
              {
                kind: "LinkedField",
                alias: null,
                name: "absence",
                storageKey: null,
                args: null,
                concreteType: "AbsenceType",
                plural: false,
                selections: [v46, v54, v7],
              },
              v12,
            ],
          },
        ],
      },
      v20,
    ],
    v68 = [v27],
    v69 = ["v", "d", "o"],
    v70 = [
      {
        kind: "Literal",
        name: "absenceStatus",
        value: ["r", "c", "a"],
        type: "[String]",
      },
      {
        kind: "Literal",
        name: "absenceType",
        value: v69,
        type: "[String]",
      },
      v63,
      v64,
      v65,
    ],
    v71 = {
      kind: "Literal",
      name: "future",
      value: true,
      type: "Boolean",
    },
    v72 = {
      kind: "Literal",
      name: "types",
      value: v69,
      type: "[String]",
    },
    v73 = [
      {
        kind: "Variable",
        name: "after",
        variableName: "afterAccepted",
        type: "String",
      },
      {
        kind: "Variable",
        name: "first",
        variableName: "countAccepted",
        type: "Int",
      },
      v71,
      v50,
      v72,
    ],
    v74 = {
      kind: "ScalarField",
      alias: null,
      name: "statusComment",
      args: null,
      storageKey: null,
    },
    v75 = [
      {
        kind: "LinkedField",
        alias: null,
        name: "edges",
        storageKey: null,
        args: null,
        concreteType: "AbsenceEdge",
        plural: true,
        selections: [
          {
            kind: "LinkedField",
            alias: null,
            name: "node",
            storageKey: null,
            args: null,
            concreteType: "AbsenceType",
            plural: false,
            selections: [v51, v52, v36, v74, v53, v46, v9, v7, v12],
          },
          v13,
        ],
      },
      v20,
    ],
    v76 = [
      {
        kind: "Variable",
        name: "after",
        variableName: "afterPending",
        type: "String",
      },
      {
        kind: "Variable",
        name: "first",
        variableName: "countPending",
        type: "Int",
      },
      v71,
      {
        kind: "Literal",
        name: "statuses",
        value: ["p"],
        type: "[String]",
      },
      v72,
    ],
    v77 = [
      {
        kind: "Variable",
        name: "after",
        variableName: "afterRejected",
        type: "String",
      },
      {
        kind: "Variable",
        name: "first",
        variableName: "countRejected",
        type: "Int",
      },
      v71,
      {
        kind: "Literal",
        name: "statuses",
        value: ["r"],
        type: "[String]",
      },
      v72,
    ],
    v78 = [
      {
        kind: "Variable",
        name: "after",
        variableName: "afterCancelled",
        type: "String",
      },
      {
        kind: "Variable",
        name: "first",
        variableName: "countCancelled",
        type: "Int",
      },
      v71,
      {
        kind: "Literal",
        name: "statuses",
        value: ["c"],
        type: "[String]",
      },
      v72,
    ],
    v79 = {
      kind: "ScalarField",
      alias: null,
      name: "dayPresences",
      args: null,
      storageKey: null,
    },
    v80 = {
      kind: "ScalarField",
      alias: null,
      name: "year",
      args: null,
      storageKey: null,
    },
    v81 = {
      kind: "ScalarField",
      alias: null,
      name: "weekOfYear",
      args: null,
      storageKey: null,
    },
    v82 = [
      {
        kind: "Literal",
        name: "last",
        value: 10,
        type: "Int",
      },
      {
        kind: "Literal",
        name: "orderByWeek",
        value: true,
        type: "Boolean",
      },
    ];
  return {
    kind: "Request",
    operationKind: "query",
    name: "QueryComponentQuery",
    id: null,
    text:
      'query QueryComponentQuery(\n  $countPending: Int!\n  $afterPending: String\n  $countAccepted: Int!\n  $afterAccepted: String\n  $countRejected: Int!\n  $afterRejected: String\n  $countCancelled: Int!\n  $afterCancelled: String\n) {\n  user {\n    ...Routes_user_3WGgZc\n    id\n  }\n}\n\nfragment Routes_user_3WGgZc on UserType {\n  ...BaseHorizontal_user\n  ...Dashboard_user_3WGgZc\n  ...Account_user\n  ...Absences_user_3WGgZc\n  displayName\n  isStaff\n}\n\nfragment BaseHorizontal_user on UserType {\n  ...HeaderHorizontal_user\n}\n\nfragment Dashboard_user_3WGgZc on UserType {\n  id\n  email\n  ...News_user\n  ...Tasks_user_3WGgZc\n  ...Schedule_user\n}\n\nfragment Account_user on UserType {\n  pk\n  firstName\n  lastName\n  email\n  phoneNumber\n  bankAccount\n}\n\nfragment Absences_user_3WGgZc on UserType {\n  ...AbsencesCalendar_user\n  ...AbsencesTabs_user_3WGgZc\n  ...AbsencesAndVacationsModal_user\n  unusedAbsenceDays\n}\n\nfragment AbsencesCalendar_user on UserType {\n  monthAbsences: absences(last: 512) {\n    edges {\n      node {\n        dateFrom\n        dateTo\n        note\n        absenceTypeDisplay\n        absenceType\n        absenceLength\n        status\n        statusDisplay\n        id\n        pk\n        statusComment\n        file\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  bankHolidays(first: 10) {\n    edges {\n      node {\n        dateFrom\n        dateTo\n        description\n        id\n      }\n    }\n  }\n  remoteDays(first: 30) {\n    edges {\n      node {\n        id\n        pk\n        date\n      }\n    }\n  }\n  calendarMeetings: meetings(priority: true) {\n    edges {\n      node {\n        createdAt\n        updatedAt\n        body\n        name\n        receivers {\n          edges {\n            node {\n              lastName\n              firstName\n              pk\n              id\n            }\n          }\n        }\n        createdBy {\n          lastName\n          firstName\n          id\n        }\n        meetingDate\n        pk\n        id\n        deleted\n        public\n        priority\n      }\n    }\n  }\n}\n\nfragment AbsencesTabs_user_3WGgZc on UserType {\n  notifications(management: false, absenceStatus: ["r", "c", "a"], absenceType: ["v", "d", "o"], first: 16, hidden: false) {\n    edges {\n      cursor\n      node {\n        pk\n        id\n        seen\n        hidden\n        absenceStatus\n        absence {\n          status\n          absenceType\n          id\n        }\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...AcceptedAbsencesTab_user_3QllOe\n  ...PendingAbsencesTab_user_1Uuf9N\n  ...RejectedAbsencesTab_user_1E8eg8\n  ...CancelledAbsencesTab_user_4ywQFZ\n}\n\nfragment AbsencesAndVacationsModal_user on UserType {\n  allAbsences: absences(last: 512) {\n    edges {\n      node {\n        dateFrom\n        absenceLength\n        dateTo\n        status\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment AcceptedAbsencesTab_user_3QllOe on UserType {\n  acceptedAbsences: absences(types: ["v", "d", "o"], statuses: ["a"], future: true, first: $countAccepted, after: $afterAccepted) {\n    edges {\n      node {\n        dateFrom\n        dateTo\n        note\n        statusComment\n        absenceTypeDisplay\n        status\n        createdAt\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PendingAbsencesTab_user_1Uuf9N on UserType {\n  pendingAbsences: absences(types: ["v", "d", "o"], statuses: ["p"], future: true, first: $countPending, after: $afterPending) {\n    edges {\n      node {\n        id\n        pk\n        dateFrom\n        dateTo\n        note\n        statusComment\n        absenceTypeDisplay\n        absenceLength\n        absenceType\n        status\n        createdAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RejectedAbsencesTab_user_1E8eg8 on UserType {\n  rejectedAbsences: absences(types: ["v", "d", "o"], statuses: ["r"], future: true, first: $countRejected, after: $afterRejected) {\n    edges {\n      node {\n        dateFrom\n        dateTo\n        note\n        statusComment\n        absenceTypeDisplay\n        status\n        createdAt\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CancelledAbsencesTab_user_4ywQFZ on UserType {\n  cancelledAbsences: absences(types: ["v", "d", "o"], statuses: ["c"], future: true, first: $countCancelled, after: $afterCancelled) {\n    edges {\n      node {\n        dateFrom\n        dateTo\n        note\n        statusComment\n        absenceTypeDisplay\n        status\n        createdAt\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment News_user on UserType {\n  ...Clock_user\n  ...UsersTable_user\n}\n\nfragment Tasks_user_3WGgZc on UserType {\n  ...TaskTimer_user\n  ...CompletedTasks_user\n  ...ToDo_user\n  ...Events_user\n  ...ReportsGraph_user\n  ...VacationsBar_user_3WGgZc\n}\n\nfragment Schedule_user on UserType {\n  ...WeekSchedule_user\n  ...ModalWeek_user\n  firstTimetable\n  secondTimetable\n  timetables(last: 10, orderByWeek: true) {\n    edges {\n      node {\n        year\n        weekOfYear\n        dayPresences\n        dayPresencesIncidental\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  timetableTemplate {\n    edges {\n      node {\n        id\n        active\n        dayPresences\n      }\n    }\n  }\n}\n\nfragment WeekSchedule_user on UserType {\n  ...ModalWeek_user\n  firstTimetable\n  secondTimetable\n  timetables(last: 10, orderByWeek: true) {\n    edges {\n      node {\n        year\n        weekOfYear\n        dayPresences\n        dayPresencesIncidental\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment ModalWeek_user on UserType {\n  currentWeekTimetable {\n    dayPresences\n    year\n    weekOfYear\n    id\n  }\n  id\n  pk\n  firstTimetable\n  secondTimetable\n  timetables(last: 10, orderByWeek: true) {\n    edges {\n      node {\n        weekOfYear\n        dayPresences\n        dayPresencesIncidental\n        year\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment TaskTimer_user on UserType {\n  ...ModalAddTask_user\n}\n\nfragment CompletedTasks_user on UserType {\n  ...ModalAddTaskButton_user\n  reports(period: 0, last: 100) {\n    edges {\n      node {\n        id\n        pk\n        afterWork\n        project {\n          pk\n          name\n          color\n          id\n        }\n        milestone {\n          pk\n          id\n        }\n        reportType {\n          pk\n          labelDisplay\n          color\n          id\n        }\n        numberOfMinutes\n        note\n        taskId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  ...ModalTasksButton_user\n}\n\nfragment ToDo_user on UserType {\n  ...ModalMore_user\n  todos(first: 10) {\n    edges {\n      node {\n        id\n        pk\n        body\n        reminder\n        isDone\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Events_user on UserType {\n  ...EventsList_user\n  ...MeetingsList_user\n  ...DashboardMeetingModal_user\n  eventsNotifications: notifications(management: false, meeting: true, first: 16, hidden: false) {\n    edges {\n      cursor\n      node {\n        pk\n        id\n        seen\n        hidden\n        absenceStatus\n        absence {\n          status\n          absenceType\n          id\n        }\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ReportsGraph_user on UserType {\n  projectEmployeesTimeSpent(last: 100) {\n    edges {\n      node {\n        id\n        pk\n        project {\n          name\n          id\n          pk\n          color\n        }\n        monthlyTimeSpent\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment VacationsBar_user_3WGgZc on UserType {\n  ...AbsencesAndVacationsModal_user\n  ...AbsencesTabs_user_3WGgZc\n}\n\nfragment EventsList_user on UserType {\n  lastMessages: receivedMessages(first: 6) {\n    pageInfo {\n      startCursor\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        sender {\n          displayName\n          id\n        }\n        body\n        createdAt\n        sentToAll\n        receivers {\n          edges {\n            node {\n              firstName\n              lastName\n              id\n            }\n          }\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment MeetingsList_user on UserType {\n  meetings(first: 6) {\n    pageInfo {\n      startCursor\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        createdAt\n        updatedAt\n        body\n        name\n        receivers {\n          edges {\n            node {\n              lastName\n              firstName\n              id\n            }\n          }\n        }\n        createdBy {\n          lastName\n          firstName\n          id\n        }\n        meetingDate\n        pk\n        id\n        deleted\n        public\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment DashboardMeetingModal_user on UserType {\n  pk\n  id\n  users(last: 512) {\n    edges {\n      node {\n        pk\n        id\n        displayName\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment ModalMore_user on UserType {\n  displayName\n}\n\nfragment ModalAddTaskButton_user on UserType {\n  defaultRole {\n    pk\n    labelDisplay\n    id\n  }\n  allRoles {\n    edges {\n      node {\n        pk\n        labelDisplay\n        id\n      }\n    }\n  }\n  projectEmployees(first: 100) {\n    edges {\n      node {\n        pk\n        active\n        project {\n          pk\n          name\n          milestones(active: true) {\n            edges {\n              node {\n                pk\n                name\n                endDate\n                id\n              }\n            }\n          }\n          id\n        }\n        role {\n          label\n          labelDisplay\n          pk\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ModalTasksButton_user on UserType {\n  ...CompletedTasksModal_user\n  reportsOld: reports(period: 14, last: 70, periodTo: 1) {\n    edges {\n      node {\n        id\n        pk\n        createdAt\n        project {\n          pk\n          name\n          color\n          id\n        }\n        milestone {\n          pk\n          id\n        }\n        reportType {\n          pk\n          labelDisplay\n          color\n          id\n        }\n        numberOfMinutes\n        note\n        taskId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  id\n}\n\nfragment CompletedTasksModal_user on UserType {\n  ...ModalAddTaskButton_user\n  reports(period: 0, last: 100) {\n    edges {\n      node {\n        id\n        pk\n        afterWork\n        project {\n          pk\n          name\n          color\n          id\n        }\n        milestone {\n          pk\n          id\n        }\n        reportType {\n          pk\n          labelDisplay\n          color\n          id\n        }\n        numberOfMinutes\n        note\n        taskId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment ModalAddTask_user on UserType {\n  defaultRole {\n    pk\n    labelDisplay\n    id\n  }\n  allRoles {\n    edges {\n      node {\n        pk\n        labelDisplay\n        id\n      }\n    }\n  }\n  projectEmployees(first: 100) {\n    edges {\n      node {\n        pk\n        active\n        project {\n          pk\n          name\n          milestones(active: true) {\n            edges {\n              node {\n                pk\n                name\n                endDate\n                id\n              }\n            }\n          }\n          id\n        }\n        role {\n          label\n          labelDisplay\n          pk\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Clock_user on UserType {\n  ...ClockButtons_user\n  todayRealWorktime\n  todayDeclaredWorktime\n  lastActivity {\n    activity\n    createdAt\n    stopBreakTime\n    time\n    id\n  }\n  lastActivityToday {\n    activity\n    createdAt\n    stopBreakTime\n    time\n    id\n  }\n  absences(today: true) {\n    edges {\n      node {\n        pk\n        id\n        absenceLength\n        status\n      }\n    }\n  }\n  todayActivities(first: 20) {\n    edges {\n      node {\n        time\n        createdAt\n        activity\n        activityDisplay\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  reports(period: 0, last: 100) {\n    edges {\n      node {\n        numberOfMinutes\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  todayAbsences: absences(today: true, last: 1) {\n    edges {\n      node {\n        id\n        absenceLength\n      }\n    }\n  }\n  latenesses(today: true, first: 1) {\n    edges {\n      node {\n        id\n        pk\n        declaredTime\n        note\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UsersTable_user on UserType {\n  users(last: 512) {\n    edges {\n      node {\n        pk\n        displayName\n        isRemote\n        lastActivityToday {\n          activity\n          activityDisplay\n          time\n          stopBreakTime\n          id\n        }\n        todayDeclaredWorktime\n        expectedEndWorkTime\n        latenesses(today: true) {\n          edges {\n            node {\n              declaredTime\n              id\n            }\n          }\n        }\n        absences(today: true, statuses: ["a"]) {\n          edges {\n            node {\n              dateFrom\n              dateTo\n              absenceLength\n              absenceTypeDisplay\n              absenceType\n              id\n            }\n          }\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment ClockButtons_user on UserType {\n  ...EndWorkModal_user\n  ...ExtraWorkModal_user\n  ...FinishWorkModal_user\n  lastActivity {\n    activity\n    createdAt\n    id\n  }\n}\n\nfragment EndWorkModal_user on UserType {\n  ...SmallTaskForm_user\n  todayDeclaredWorktime\n  todayActivities(first: 20) {\n    edges {\n      node {\n        time\n        activity\n        activityDisplay\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  defaultRole {\n    pk\n    labelDisplay\n    id\n  }\n  dailyReport {\n    comment\n    id\n    extraTimeFrom\n    extraTimeTo\n    pk\n  }\n  allRoles {\n    edges {\n      node {\n        pk\n        labelDisplay\n        id\n      }\n    }\n  }\n  projectEmployees(first: 100) {\n    edges {\n      node {\n        pk\n        project {\n          pk\n          name\n          id\n        }\n        role {\n          label\n          labelDisplay\n          pk\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  reports(period: 0, last: 100) {\n    edges {\n      node {\n        id\n        pk\n        afterWork\n        project {\n          pk\n          name\n          color\n          id\n        }\n        milestone {\n          pk\n          id\n        }\n        reportType {\n          pk\n          labelDisplay\n          color\n          id\n        }\n        numberOfMinutes\n        note\n        taskId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment ExtraWorkModal_user on UserType {\n  ...SmallTaskForm_user\n  todayDeclaredWorktime\n  todayActivities(first: 20) {\n    edges {\n      node {\n        time\n        activity\n        activityDisplay\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  defaultRole {\n    pk\n    labelDisplay\n    id\n  }\n  dailyReport {\n    comment\n    id\n    extraTimeFrom\n    extraTimeTo\n    pk\n  }\n  allRoles {\n    edges {\n      node {\n        pk\n        labelDisplay\n        id\n      }\n    }\n  }\n  projectEmployees(first: 100) {\n    edges {\n      node {\n        pk\n        project {\n          pk\n          name\n          id\n        }\n        role {\n          label\n          labelDisplay\n          pk\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  reports(period: 0, last: 100) {\n    edges {\n      node {\n        id\n        pk\n        afterWork\n        project {\n          pk\n          name\n          color\n          id\n        }\n        reportType {\n          pk\n          labelDisplay\n          color\n          id\n        }\n        numberOfMinutes\n        note\n        taskId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment FinishWorkModal_user on UserType {\n  ...SmallTaskForm_user\n  declaredWorktime(offset: 0)\n  dayActivities(offset: 0) {\n    edges {\n      node {\n        time\n        activity\n        activityDisplay\n        id\n      }\n    }\n  }\n  lastActivity {\n    activity\n    createdAt\n    stopBreakTime\n    time\n    id\n  }\n  lastStartWork {\n    time\n    id\n  }\n  defaultRole {\n    pk\n    labelDisplay\n    id\n  }\n  dailyReportOffset: dailyReport(offset: 0) {\n    comment\n    id\n    extraTimeFrom\n    extraTimeTo\n    pk\n  }\n  allRoles {\n    edges {\n      node {\n        pk\n        labelDisplay\n        id\n      }\n    }\n  }\n  projectEmployees(first: 100) {\n    edges {\n      node {\n        pk\n        project {\n          pk\n          name\n          id\n        }\n        role {\n          label\n          labelDisplay\n          pk\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  reportsOffset: reports(period: 0, periodTo: 0, last: 100) {\n    edges {\n      node {\n        id\n        pk\n        afterWork\n        project {\n          pk\n          name\n          color\n          id\n        }\n        reportType {\n          pk\n          labelDisplay\n          color\n          id\n        }\n        numberOfMinutes\n        note\n        taskId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment SmallTaskForm_user on UserType {\n  defaultRole {\n    pk\n    labelDisplay\n    id\n  }\n  allRoles {\n    edges {\n      node {\n        pk\n        labelDisplay\n        id\n      }\n    }\n  }\n  projectEmployees(first: 100) {\n    edges {\n      node {\n        pk\n        active\n        project {\n          pk\n          name\n          milestones(active: true) {\n            edges {\n              node {\n                pk\n                name\n                endDate\n                id\n              }\n            }\n          }\n          id\n        }\n        role {\n          label\n          labelDisplay\n          pk\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment HeaderHorizontal_user on UserType {\n  displayName\n  isStaff\n}\n',
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "QueryComponentQuery",
      type: "Query",
      metadata: null,
      argumentDefinitions: v0,
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "user",
          storageKey: null,
          args: null,
          concreteType: "UserType",
          plural: false,
          selections: [
            {
              kind: "FragmentSpread",
              name: "Routes_user",
              args: [
                {
                  kind: "Variable",
                  name: "afterAccepted",
                  variableName: "afterAccepted",
                  type: null,
                },
                {
                  kind: "Variable",
                  name: "afterCancelled",
                  variableName: "afterCancelled",
                  type: null,
                },
                {
                  kind: "Variable",
                  name: "afterPending",
                  variableName: "afterPending",
                  type: null,
                },
                {
                  kind: "Variable",
                  name: "afterRejected",
                  variableName: "afterRejected",
                  type: null,
                },
                {
                  kind: "Variable",
                  name: "countAccepted",
                  variableName: "countAccepted",
                  type: null,
                },
                {
                  kind: "Variable",
                  name: "countCancelled",
                  variableName: "countCancelled",
                  type: null,
                },
                {
                  kind: "Variable",
                  name: "countPending",
                  variableName: "countPending",
                  type: null,
                },
                {
                  kind: "Variable",
                  name: "countRejected",
                  variableName: "countRejected",
                  type: null,
                },
              ],
            },
          ],
        },
      ],
    },
    operation: {
      kind: "Operation",
      name: "QueryComponentQuery",
      argumentDefinitions: v0,
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "user",
          storageKey: null,
          args: null,
          concreteType: "UserType",
          plural: false,
          selections: [
            {
              kind: "LinkedField",
              alias: "lastMessages",
              name: "receivedMessages",
              storageKey: "receivedMessages(first:6)",
              args: v1,
              concreteType: "MessageConnection",
              plural: false,
              selections: [
                v5,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "MessageEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "MessageType",
                      plural: false,
                      selections: [
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "sender",
                          storageKey: null,
                          args: null,
                          concreteType: "UserType",
                          plural: false,
                          selections: [v6, v7],
                        },
                        v8,
                        v9,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "sentToAll",
                          args: null,
                          storageKey: null,
                        },
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "receivers",
                          storageKey: null,
                          args: null,
                          concreteType: "UserTypeConnection",
                          plural: false,
                          selections: [
                            {
                              kind: "LinkedField",
                              alias: null,
                              name: "edges",
                              storageKey: null,
                              args: null,
                              concreteType: "UserTypeEdge",
                              plural: true,
                              selections: [
                                {
                                  kind: "LinkedField",
                                  alias: null,
                                  name: "node",
                                  storageKey: null,
                                  args: null,
                                  concreteType: "UserType",
                                  plural: false,
                                  selections: [v10, v11, v7],
                                },
                              ],
                            },
                          ],
                        },
                        v7,
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
              ],
            },
            {
              kind: "LinkedHandle",
              alias: "lastMessages",
              name: "receivedMessages",
              args: v1,
              handle: "connection",
              key: "EventList_lastMessages",
              filters: [],
            },
            v6,
            v7,
            {
              kind: "ScalarField",
              alias: null,
              name: "email",
              args: null,
              storageKey: null,
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "defaultRole",
              storageKey: null,
              args: null,
              concreteType: "RoleType",
              plural: false,
              selections: v16,
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "allRoles",
              storageKey: null,
              args: null,
              concreteType: "RoleConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "RoleEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "RoleType",
                      plural: false,
                      selections: v16,
                    },
                  ],
                },
              ],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "projectEmployees",
              storageKey: "projectEmployees(first:100)",
              args: v17,
              concreteType: "ProjectEmployeeConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "ProjectEmployeeEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "ProjectEmployeeType",
                      plural: false,
                      selections: [
                        v14,
                        v18,
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "project",
                          storageKey: null,
                          args: null,
                          concreteType: "ProjectType",
                          plural: false,
                          selections: [
                            v14,
                            v19,
                            {
                              kind: "LinkedField",
                              alias: null,
                              name: "milestones",
                              storageKey: "milestones(active:true)",
                              args: [
                                {
                                  kind: "Literal",
                                  name: "active",
                                  value: true,
                                  type: "Boolean",
                                },
                              ],
                              concreteType: "MilestoneConnection",
                              plural: false,
                              selections: [
                                {
                                  kind: "LinkedField",
                                  alias: null,
                                  name: "edges",
                                  storageKey: null,
                                  args: null,
                                  concreteType: "MilestoneEdge",
                                  plural: true,
                                  selections: [
                                    {
                                      kind: "LinkedField",
                                      alias: null,
                                      name: "node",
                                      storageKey: null,
                                      args: null,
                                      concreteType: "MilestoneType",
                                      plural: false,
                                      selections: [
                                        v14,
                                        v19,
                                        {
                                          kind: "ScalarField",
                                          alias: null,
                                          name: "endDate",
                                          args: null,
                                          storageKey: null,
                                        },
                                        v7,
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            v7,
                          ],
                        },
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "role",
                          storageKey: null,
                          args: null,
                          concreteType: "RoleType",
                          plural: false,
                          selections: [
                            {
                              kind: "ScalarField",
                              alias: null,
                              name: "label",
                              args: null,
                              storageKey: null,
                            },
                            v15,
                            v14,
                            v7,
                          ],
                        },
                        v7,
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
                v20,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "projectEmployees",
              args: v17,
              handle: "connection",
              key: "User_projectEmployees",
              filters: [],
            },
            v21,
            {
              kind: "LinkedField",
              alias: null,
              name: "todayActivities",
              storageKey: "todayActivities(first:20)",
              args: v22,
              concreteType: "EmployeeActivityConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "EmployeeActivityEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "EmployeeActivityType",
                      plural: false,
                      selections: [v23, v24, v25, v7, v12, v9],
                    },
                    v13,
                  ],
                },
                v20,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "todayActivities",
              args: v22,
              handle: "connection",
              key: "user_todayActivities",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "dailyReport",
              storageKey: null,
              args: null,
              concreteType: "DailyReportType",
              plural: false,
              selections: v26,
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "reports",
              storageKey: "reports(last:100,period:0)",
              args: v29,
              concreteType: "ReportConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "ReportEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "ReportType",
                      plural: false,
                      selections: [
                        v7,
                        v14,
                        v30,
                        v32,
                        v33,
                        v34,
                        v35,
                        v36,
                        v37,
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
                v38,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "reports",
              args: v29,
              handle: "connection",
              key: "CompletedTasks_reports",
              filters: [],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "reports",
              args: v29,
              handle: "connection",
              key: "Clock_reports",
              filters: [],
            },
            {
              kind: "ScalarField",
              alias: null,
              name: "declaredWorktime",
              args: v39,
              storageKey: "declaredWorktime(offset:0)",
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "dayActivities",
              storageKey: "dayActivities(offset:0)",
              args: v39,
              concreteType: "EmployeeActivityConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "EmployeeActivityEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "EmployeeActivityType",
                      plural: false,
                      selections: [v23, v24, v25, v7],
                    },
                  ],
                },
              ],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "lastActivity",
              storageKey: null,
              args: null,
              concreteType: "EmployeeActivityType",
              plural: false,
              selections: v41,
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "lastStartWork",
              storageKey: null,
              args: null,
              concreteType: "EmployeeActivityType",
              plural: false,
              selections: [v23, v7],
            },
            {
              kind: "LinkedField",
              alias: "dailyReportOffset",
              name: "dailyReport",
              storageKey: "dailyReport(offset:0)",
              args: v39,
              concreteType: "DailyReportType",
              plural: false,
              selections: v26,
            },
            {
              kind: "LinkedField",
              alias: "reportsOffset",
              name: "reports",
              storageKey: "reports(last:100,period:0,periodTo:0)",
              args: v42,
              concreteType: "ReportConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "ReportEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "ReportType",
                      plural: false,
                      selections: [v7, v14, v30, v32, v34, v35, v36, v37, v12],
                    },
                    v13,
                  ],
                },
                v38,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: "reportsOffset",
              name: "reports",
              args: v42,
              handle: "connection",
              key: "FinishWorkModal_reportsOffset",
              filters: [],
            },
            {
              kind: "ScalarField",
              alias: null,
              name: "todayRealWorktime",
              args: null,
              storageKey: null,
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "lastActivityToday",
              storageKey: null,
              args: null,
              concreteType: "EmployeeActivityType",
              plural: false,
              selections: v41,
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "absences",
              storageKey: "absences(today:true)",
              args: v44,
              concreteType: "AbsenceConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "AbsenceEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "AbsenceType",
                      plural: false,
                      selections: [v14, v7, v45, v46],
                    },
                  ],
                },
              ],
            },
            {
              kind: "LinkedField",
              alias: "todayAbsences",
              name: "absences",
              storageKey: "absences(last:1,today:true)",
              args: [
                {
                  kind: "Literal",
                  name: "last",
                  value: 1,
                  type: "Int",
                },
                v43,
              ],
              concreteType: "AbsenceConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "AbsenceEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "AbsenceType",
                      plural: false,
                      selections: [v7, v45],
                    },
                  ],
                },
              ],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "latenesses",
              storageKey: "latenesses(first:1,today:true)",
              args: v47,
              concreteType: "LatenessConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "LatenessEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "LatenessType",
                      plural: false,
                      selections: [v7, v14, v48, v36, v12],
                    },
                    v13,
                  ],
                },
                v20,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "latenesses",
              args: v47,
              handle: "connection",
              key: "Clock_latenesses",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "users",
              storageKey: "users(last:512)",
              args: v49,
              concreteType: "UserConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "UserEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "UserType",
                      plural: false,
                      selections: [
                        v14,
                        v6,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "isRemote",
                          args: null,
                          storageKey: null,
                        },
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "lastActivityToday",
                          storageKey: null,
                          args: null,
                          concreteType: "EmployeeActivityType",
                          plural: false,
                          selections: [v24, v25, v23, v40, v7],
                        },
                        v21,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "expectedEndWorkTime",
                          args: null,
                          storageKey: null,
                        },
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "latenesses",
                          storageKey: "latenesses(today:true)",
                          args: v44,
                          concreteType: "LatenessConnection",
                          plural: false,
                          selections: [
                            {
                              kind: "LinkedField",
                              alias: null,
                              name: "edges",
                              storageKey: null,
                              args: null,
                              concreteType: "LatenessEdge",
                              plural: true,
                              selections: [
                                {
                                  kind: "LinkedField",
                                  alias: null,
                                  name: "node",
                                  storageKey: null,
                                  args: null,
                                  concreteType: "LatenessType",
                                  plural: false,
                                  selections: [v48, v7],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "absences",
                          storageKey: 'absences(statuses:["a"],today:true)',
                          args: [v50, v43],
                          concreteType: "AbsenceConnection",
                          plural: false,
                          selections: [
                            {
                              kind: "LinkedField",
                              alias: null,
                              name: "edges",
                              storageKey: null,
                              args: null,
                              concreteType: "AbsenceEdge",
                              plural: true,
                              selections: [
                                {
                                  kind: "LinkedField",
                                  alias: null,
                                  name: "node",
                                  storageKey: null,
                                  args: null,
                                  concreteType: "AbsenceType",
                                  plural: false,
                                  selections: [v51, v52, v45, v53, v54, v7],
                                },
                              ],
                            },
                          ],
                        },
                        v7,
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
                v38,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "users",
              args: v49,
              handle: "connection",
              key: "UsersTable_users",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: "reportsOld",
              name: "reports",
              storageKey: "reports(last:70,period:14,periodTo:1)",
              args: v55,
              concreteType: "ReportConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "ReportEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "ReportType",
                      plural: false,
                      selections: [
                        v7,
                        v14,
                        v9,
                        v32,
                        v33,
                        v34,
                        v35,
                        v36,
                        v37,
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
                v38,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: "reportsOld",
              name: "reports",
              args: v55,
              handle: "connection",
              key: "ModalTasksButton_reportsOld",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "todos",
              storageKey: "todos(first:10)",
              args: v56,
              concreteType: "ToDoConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "ToDoEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "ToDoType",
                      plural: false,
                      selections: [
                        v7,
                        v14,
                        v8,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "reminder",
                          args: null,
                          storageKey: null,
                        },
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "isDone",
                          args: null,
                          storageKey: null,
                        },
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
                v20,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "todos",
              args: v56,
              handle: "connection",
              key: "ToDo_todos",
              filters: [],
            },
            {
              kind: "ScalarField",
              alias: null,
              name: "isStaff",
              args: null,
              storageKey: null,
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "meetings",
              storageKey: "meetings(first:6)",
              args: v1,
              concreteType: "MeetingConnection",
              plural: false,
              selections: [
                v5,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "MeetingEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "MeetingType",
                      plural: false,
                      selections: [
                        v57,
                        v9,
                        v8,
                        v19,
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "receivers",
                          storageKey: null,
                          args: null,
                          concreteType: "UserTypeConnection",
                          plural: false,
                          selections: [
                            {
                              kind: "LinkedField",
                              alias: null,
                              name: "edges",
                              storageKey: null,
                              args: null,
                              concreteType: "UserTypeEdge",
                              plural: true,
                              selections: [
                                {
                                  kind: "LinkedField",
                                  alias: null,
                                  name: "node",
                                  storageKey: null,
                                  args: null,
                                  concreteType: "UserType",
                                  plural: false,
                                  selections: v58,
                                },
                              ],
                            },
                          ],
                        },
                        v59,
                        v60,
                        v14,
                        v7,
                        v61,
                        v62,
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
              ],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "meetings",
              args: v1,
              handle: "connection",
              key: "MeetingsList_meetings",
              filters: [],
            },
            v14,
            {
              kind: "LinkedField",
              alias: "eventsNotifications",
              name: "notifications",
              storageKey:
                "notifications(first:16,hidden:false,management:false,meeting:true)",
              args: v66,
              concreteType: "NotificationConnection",
              plural: false,
              selections: v67,
            },
            {
              kind: "LinkedHandle",
              alias: "eventsNotifications",
              name: "notifications",
              args: v66,
              handle: "connection",
              key: "Events_eventsNotifications",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "projectEmployeesTimeSpent",
              storageKey: "projectEmployeesTimeSpent(last:100)",
              args: v68,
              concreteType: "ProjectEmployeeConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "ProjectEmployeeEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "ProjectEmployeeType",
                      plural: false,
                      selections: [
                        v7,
                        v14,
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "project",
                          storageKey: null,
                          args: null,
                          concreteType: "ProjectType",
                          plural: false,
                          selections: [v19, v7, v14, v31],
                        },
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "monthlyTimeSpent",
                          args: null,
                          storageKey: null,
                        },
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
                v38,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "projectEmployeesTimeSpent",
              args: v68,
              handle: "connection",
              key: "ReportsGraph_projectEmployeesTimeSpent",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: "allAbsences",
              name: "absences",
              storageKey: "absences(last:512)",
              args: v49,
              concreteType: "AbsenceConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "AbsenceEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "AbsenceType",
                      plural: false,
                      selections: [v51, v45, v52, v46, v7, v12],
                    },
                    v13,
                  ],
                },
                v38,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: "allAbsences",
              name: "absences",
              args: v49,
              handle: "connection",
              key: "AbsencesCalendar_allAbsences",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "notifications",
              storageKey:
                'notifications(absenceStatus:["r","c","a"],absenceType:["v","d","o"],first:16,hidden:false,management:false)',
              args: v70,
              concreteType: "NotificationConnection",
              plural: false,
              selections: v67,
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "notifications",
              args: v70,
              handle: "connection",
              key: "AbsencesTabs_notifications",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: "acceptedAbsences",
              name: "absences",
              storageKey: null,
              args: v73,
              concreteType: "AbsenceConnection",
              plural: false,
              selections: v75,
            },
            {
              kind: "LinkedHandle",
              alias: "acceptedAbsences",
              name: "absences",
              args: v73,
              handle: "connection",
              key: "AcceptedAbsencesTab_acceptedAbsences",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: "pendingAbsences",
              name: "absences",
              storageKey: null,
              args: v76,
              concreteType: "AbsenceConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "AbsenceEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "AbsenceType",
                      plural: false,
                      selections: [
                        v53,
                        v7,
                        v51,
                        v52,
                        v36,
                        v74,
                        v14,
                        v45,
                        v54,
                        v46,
                        v9,
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
                v20,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: "pendingAbsences",
              name: "absences",
              args: v76,
              handle: "connection",
              key: "PendingAbsencesTab_pendingAbsences",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: "rejectedAbsences",
              name: "absences",
              storageKey: null,
              args: v77,
              concreteType: "AbsenceConnection",
              plural: false,
              selections: v75,
            },
            {
              kind: "LinkedHandle",
              alias: "rejectedAbsences",
              name: "absences",
              args: v77,
              handle: "connection",
              key: "RejectedAbsencesTab_rejectedAbsences",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: "cancelledAbsences",
              name: "absences",
              storageKey: null,
              args: v78,
              concreteType: "AbsenceConnection",
              plural: false,
              selections: v75,
            },
            {
              kind: "LinkedHandle",
              alias: "cancelledAbsences",
              name: "absences",
              args: v78,
              handle: "connection",
              key: "CancelledAbsencesTab_cancelledAbsences",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "currentWeekTimetable",
              storageKey: null,
              args: null,
              concreteType: "TimetableType",
              plural: false,
              selections: [v79, v80, v81, v7],
            },
            {
              kind: "ScalarField",
              alias: null,
              name: "firstTimetable",
              args: null,
              storageKey: null,
            },
            {
              kind: "ScalarField",
              alias: null,
              name: "secondTimetable",
              args: null,
              storageKey: null,
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "timetables",
              storageKey: "timetables(last:10,orderByWeek:true)",
              args: v82,
              concreteType: "TimetableConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "TimetableEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "TimetableType",
                      plural: false,
                      selections: [
                        v81,
                        v79,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "dayPresencesIncidental",
                          args: null,
                          storageKey: null,
                        },
                        v80,
                        v7,
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
                v38,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: null,
              name: "timetables",
              args: v82,
              handle: "connection",
              key: "ModalWeek_timetables",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "timetableTemplate",
              storageKey: null,
              args: null,
              concreteType: "TimetableTemplateConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "TimetableTemplateEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "TimetableTemplateType",
                      plural: false,
                      selections: [v7, v18, v79],
                    },
                  ],
                },
              ],
            },
            v10,
            v11,
            {
              kind: "ScalarField",
              alias: null,
              name: "phoneNumber",
              args: null,
              storageKey: null,
            },
            {
              kind: "ScalarField",
              alias: null,
              name: "bankAccount",
              args: null,
              storageKey: null,
            },
            {
              kind: "LinkedField",
              alias: "monthAbsences",
              name: "absences",
              storageKey: "absences(last:512)",
              args: v49,
              concreteType: "AbsenceConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "AbsenceEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "AbsenceType",
                      plural: false,
                      selections: [
                        v46,
                        v51,
                        v36,
                        v53,
                        v54,
                        v45,
                        v52,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "statusDisplay",
                          args: null,
                          storageKey: null,
                        },
                        v7,
                        v14,
                        v74,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "file",
                          args: null,
                          storageKey: null,
                        },
                        v12,
                      ],
                    },
                    v13,
                  ],
                },
                v38,
              ],
            },
            {
              kind: "LinkedHandle",
              alias: "monthAbsences",
              name: "absences",
              args: v49,
              handle: "connection",
              key: "AbsencesCalendar_monthAbsences",
              filters: [],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "bankHolidays",
              storageKey: "bankHolidays(first:10)",
              args: v56,
              concreteType: "BankHolidayConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "BankHolidayEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "BankHolidayType",
                      plural: false,
                      selections: [
                        v51,
                        v52,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "description",
                          args: null,
                          storageKey: null,
                        },
                        v7,
                      ],
                    },
                  ],
                },
              ],
            },
            {
              kind: "LinkedField",
              alias: null,
              name: "remoteDays",
              storageKey: "remoteDays(first:30)",
              args: [
                {
                  kind: "Literal",
                  name: "first",
                  value: 30,
                  type: "Int",
                },
              ],
              concreteType: "RemoteWorkConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "RemoteWorkEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "RemoteWorkType",
                      plural: false,
                      selections: [
                        v7,
                        v14,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "date",
                          args: null,
                          storageKey: null,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              kind: "LinkedField",
              alias: "calendarMeetings",
              name: "meetings",
              storageKey: "meetings(priority:true)",
              args: [
                {
                  kind: "Literal",
                  name: "priority",
                  value: true,
                  type: "Boolean",
                },
              ],
              concreteType: "MeetingConnection",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "edges",
                  storageKey: null,
                  args: null,
                  concreteType: "MeetingEdge",
                  plural: true,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "node",
                      storageKey: null,
                      args: null,
                      concreteType: "MeetingType",
                      plural: false,
                      selections: [
                        v57,
                        v9,
                        v8,
                        v19,
                        {
                          kind: "LinkedField",
                          alias: null,
                          name: "receivers",
                          storageKey: null,
                          args: null,
                          concreteType: "UserTypeConnection",
                          plural: false,
                          selections: [
                            {
                              kind: "LinkedField",
                              alias: null,
                              name: "edges",
                              storageKey: null,
                              args: null,
                              concreteType: "UserTypeEdge",
                              plural: true,
                              selections: [
                                {
                                  kind: "LinkedField",
                                  alias: null,
                                  name: "node",
                                  storageKey: null,
                                  args: null,
                                  concreteType: "UserType",
                                  plural: false,
                                  selections: [v11, v10, v14, v7],
                                },
                              ],
                            },
                          ],
                        },
                        v59,
                        v60,
                        v14,
                        v7,
                        v61,
                        v62,
                        {
                          kind: "ScalarField",
                          alias: null,
                          name: "priority",
                          args: null,
                          storageKey: null,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              kind: "ScalarField",
              alias: null,
              name: "unusedAbsenceDays",
              args: null,
              storageKey: null,
            },
          ],
        },
      ],
    },
  };
})();
// prettier-ignore
(node/*: any*/).hash = '57cb59890056865446eb6af8663009f7';
module.exports = node;



// WEBPACK FOOTER //
// ./src/__generated__/QueryComponentQuery.graphql.js